import { AccountPermission } from './app/shared/consts/accountPermission';
import { MailFrequency } from './app/notifications-new/models/mail-frequency';

export const configSUSTAINABLE = {
  academondo: 'Greenlink',
  academondoDash: 'Greenlink',
  academondoCom: 'app.greenlink.dk',
  academondoUrl: 'https://app.greenlink.dk',
  supportMail: 'gogreen@greenlink.dk',
  reviewMail: 'gogreen@greenlink.dk',
  senderMail: 'gogreen@greenlink.dk',
  welcomeScientistTemplateId: 5,
  welcomeCompanyTemplateId: 5,
  inviteTemplateId: 6,

  notificationTemplateId: 7,

  dateFormat: 'da-DK',
  languageCKEditor: 'da-DK',

  language: 'da',
  defaultUserCoverUrl:
    'https://strapi-prod.sos-ch-dk-2.exo.io/ebrains_ssd_call_ebrains_website_3a68136980.jpg',
  defaultEventCoverUrlCredit: '',
  defaultEventCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fevent-cover.jpg?alt=media&token=cbbfaadc-e88c-4e86-9a3e-47ef36c97fdd',
  defaultCommunityCoverUrlCredit: '',
  defaultCommunityCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fcommunity-cover.jpg?alt=media&token=9cff048f-c0ce-4363-97b7-61f43fa1051a',
  defaultIdeaCoverUrlCredit: '',
  defaultIdeaCoverUrl:
    'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fidea-cover.png?alt=media&token=953c4f68-9802-4cf6-994f-94c3876edd9f',
  welcomeWidgetCoverUrlCredit: '',
  welcomeWidgetCoverUrl: '',

  // only select one
  welcomeWidgetIcon: false,
  welcomeWidgetIconInv: false,
  welcomeWidgetLogo: false,
  welcomeWidgetLogoInv: false,

  // only select one
  EUWelcomeWidgetLogo: false,
  EUWelcomeWidgetIcon: false,

  // welcomeWidgetVideo:
  //   'https://dandybusinesspark.dk/wp-content/uploads/2023/11/Forside-film_Low.mp4',
  // welcomeWidgetVideoHeadline: 'Samarbejde, innovation og bæredygtig vækst.',
  // welcomeWidgetVideoPrimaryColorBackground: false,
  // welcomeWidgetVideo:
  //   'https://open-entrepreneurship.com/wp-content/uploads/2017/08/v2.mp4',
  // welcomeWidgetVideoHeadline:
  //   'Turning world class research into world class companies',
  // welcomeWidgetVideoPrimaryColorBackground: true,

  showWelcomeWidget: true,

  // disabledSignupEmail: 'office@neuroscienceacademydenmark.dk',
  // disabledSignupForm: 'https://eu.jotform.com/220815942508053',

  termsLink: 'https://greenlink.dk/consent-form/',
  privacyPolicyLink: 'https://greenlink.dk/privacypolicy/',
  copyRightDate: '© 2022,',

  academondoStreet: 'Holbergsvej 22,',
  academondoPostboxCity: '8800 Viborg',
  academondoCVR: '41632437',
  academondoPhone: '+45 21 42 64 44',

  twitterLink: '', // leave blank if it should not be shown
  facebookLink: '', // leave blank if it should not be shown
  linkedinLink: '', // leave blank if it should not be shown
  instagramLink: '', // https://www.instagram.com/companyName/ // leave blank if it should not be shown
  fbPagePluginLink: '',

  showTermsInNavbarMenu: true,

  showSiteTagsAsChips: true,
  showCvTagsAsChips: true,
  showMaxSearchResultSelector: false,

  maxDistanceInSearch: 350,
  maxSearchResults: 350,
  defaultSearchType: 'All', // SearchableTypes.All
  showProfileWidgetStats: false,
  showSearchForXButtonInProfileWidget: 'Job', // SearchableTypes.Job,
  showSearchForXButtonInProfileWidgetText: 'Find Børsopslag',
  showCreateButtonCommunityInProfileWidget: false,
  showCreateButtonEventInProfileWidget: false,
  showCreateButtonIdeaInProfileWidget: false,
  showDateOnPostsInFeedWidget: false,
  showMemberCountOnEventWidget: true,

  urlForWordpressnews: null, //'https://sustainreport.dk/',
  TitleForWordpressnews: 'Sustain report',
  WordpressnewsFilter: null,
  urlForWordpressnews2: null, //'https://impactinsider.dk',
  TitleForWordpressnews2: 'Impact insider',
  Wordpressnews2Filter: null,
  EnableMultiwordpressFeeds: true,
  TitleForMultiwordpressFeeds: 'Nyheder',
  MultiwordpressFeeds: ['https://impactinsider.dk'],
  MultiwordpressFeedsFilter: null,
  urlForWordpresstools: null, // 'https://partnerskaberne.dk',
  TitleForWordpresstools: 'Værktøjer',
  WordpresstoolsFilter: 47,

  EnablePremiumCommunities: false,

  chatbotScriptUrl:
    'https://cdn.jsdelivr.net/gh/agerskov/chatbot1.6/dist/web.js', // 'https://cdn.jsdelivr.net/gh/FlowiseAI/FlowiseChatEmbed/dist/web.js';`; // 'https://cdn.jsdelivr.net/npm/flowise-embed@1.6/dist/web.js;
  // get chatbotInCornerScript() {
  //   return `
  //   import Chatbot from '${this.chatbotScriptUrl}';
  //     Chatbot.init({
  //       chatflowid: 'e085bfc8-6941-49e3-869a-0689156599f1',
  //       apiHost: '${this.chatbotBuilderApiHost}',
  //       theme: {
  //       button: {
  //         backgroundColor: '#234F4F',
  //         right: 60,
  //         bottom: 20,
  //         size: 'medium',
  //         iconColor: 'white',
  //         customIconSrc:
  //           'https://firebasestorage.googleapis.com/v0/b/academondo-demo.appspot.com/o/00000xxx%2Fchat-bubbles-question-svgrepo-com.svg?alt=media&token=8302efe5-8a2a-4042-8dda-527c74fc06ae',
  //       },
  //       chatWindow: {
  //         welcomeMessage:
  //           'Velkommen til Greenlink!',
  //         backgroundColor: '#ffffff',
  //         height: 700,
  //         width: 400,
  //         poweredByTextColor: '#303235',
  //         poweredByLink: 'https://academondo.com',
  //         poweredByText: 'Academondo',
  //         title: 'Greenlink',
  //         botMessage: {
  //           backgroundColor: '#f7f8ff',
  //           textColor: '#303235',
  //           showAvatar: true,
  //           avatarSrc:
  //             'https://firebasestorage.googleapis.com/v0/b/sustainable-denmark.appspot.com/o/AM.svg?alt=media&token=c4fd6a33-8b08-48fc-acee-8522340dc293',
  //         },
  //         userMessage: {
  //           backgroundColor: '#234F4F',
  //           textColor: '#ffffff',
  //           showAvatar: true,
  //           avatarSrc:
  //             'https://raw.githubusercontent.com/zahidkhawaja/langchain-chat-nextjs/main/public/usericon.png',
  //         },
  //         textInput: {
  //           placeholder: 'Indtast din besked her...',
  //           backgroundColor: '#ffffff',
  //           textColor: '#303235',
  //           sendButtonColor: '#234F4F',
  //         },
  //       },
  //     },
  //     chatflowConfig: {
  //       question1: 'Hvad er Greenlink?',
  //     },
  //     })`;
  // },

  umamiKey: '9cea10f9-4449-448d-be51-966ddf7e093d',

  //suggestion
  enableCategory0Suggestions: true,
  enableFOISuggestions: true,
  enableTechSuggestions: true,

  // matchMyFilter
  SkipInterests: false,
  SkipTechniques: false,
  SkipCat0: false,
  SkipCat1: false,
  SkipCat2: false,
  SkipCat3: false,
  SkipCat4: false,
  SkipCat5: false,
  SkipSiteSubtype: false,
  SkipNetworkSubtype: false,
  ExternalLinkedinFeed: '', // '67265', // remember to set Id and link in dashboard.ts
  TwitterListHref: false,
  ExternalFeedLeft: false,
  ExternalFeedRight: true,

  SSOEnabled: false,
  LinkedinEnabled: true,
  LinkedinClientId: '865gve14kylnmm',
  linkedinV2: true,
  enabledSubgroups: true,

  enabledSubgroupsInIdeas: false,
  groupSideBarExpanded: true,

  onlyCreateIdeasFromSite: false,

  expireSites: false,
  expireProfiles: false,
  startingPermissionLevel: AccountPermission.basic,
  priceOnSite: false,
  specialUserAccountTypes: [
    // AccountType.scientist,
    // AccountType.labTech,
    // AccountType.medLabTech,
    // AccountType.industry,
    // AccountType.university,
  ],

  enableEventsForUnAuthedUsers: true,
  enableCommunitiesForUnAuthedUsers: true,
  enableIdeasForUnAuthedUsers: true,

  showPrintSiteButton: false,
  showPrintableCVButton: false,
  enableEvents: true,
  enableCommunities: true,
  enableChat: true,
  groupChatEnabled: false,
  groupKanbanEnabled: true,

  canHideIdeaFromSearch: true,
  hideMentorShipOnNewMember: false,

  copyEvent: true,
  copyCommunity: true,
  copyIdea: true,
  showGroupOnGroupMap: false,
  ideaWantedExperience: false,
  ideaImages: false,

  jobWantedExperience: true,
  jobImages: 'Billeder',
  enableJobs: true,
  showJobsInSearchWhenNotLoggedIn: true,
  fillCompanyInfoFromProfileInJobPost: true,
  jobResearchQualificationsAsFilters: false,
  showMiddleName: false,

  allowMultipleItems: false,

  slimSiteIndex: false,
  siteIsUserDriven: true,
  showDepartmentInPersonalDetails: false,
  showSexInPersonalDetails: false,

  showCreateCommunityButtonForUserWithoutPermission: true,
  showCreateEventButtonForUserWithoutPermission: true,
  showCreateIdeaButtonForUserWithoutPermission: true,

  enableMagicLink: false,
  showCVRInputInSiteInfo: false,
  showSiteInfoStep: false,

  enableCoupling: false,
  showApplicationProcessFunctions: false, // leave blank if it should not be shown

  registerVisitFunctions: '', // leave blank if it should not be shown

  showRelatedJobsFunctions: true, // leave blank if it should not be shown

  showCalendarInNetworks: false, // leave as false if it should not be shown'

  showBorderedButtonsInNavBar: false, // leave as false if it should not be shown
  showCapitalizedButtonsInNavBar: false, // leave as false if it should not be shown

  showAccountChangerInNavBar: false, // leave as false if it should not be shown
  showAccountSelectorIcons: false, // leave as false if it should not be shown
  showChangeAccountTypeInSignup: true, // leave as false if it should not be shown

  enableTagUsersInComments: true, // leave as false if it should not be shown
  enableTagUsersInPosts: true, // leave as false if it should not be shown

  showSiteImageOnMap: true, // leave as false if it should not be shown
  showPlaceImageOnMap: false, // leave as false if it should not be shown
  showNetworkImageOnMap: false, // leave as false if it should not be shown
  showCommunityImageOnMap: false, // leave as false if it should not be shown
  showIdeaImageOnMap: false, // leave as false if it should not be shown
  showEventImageOnMap: false, // leave as false if it should not be shown
  showCreatorOfCommunities: true, // leave as false if it should not be shown
  showCreatorOfEvents: true, // leave as false if it should not be shown
  showCreatorOfIdeas: true, // leave as false if it should not be shown
  showOptionToRemoveUsersPostsAndEvEventsOnLeaving: false, // leave as false if it should not be shown
  showOptionToRemoveUsersPostsAndEvEventsOnRemovingUser: false, // leave as false if it should not be shown
  showInviteWidget: true, // leave as false if it should not be shown
  showBasicStep: false, // leave as false if it should not be shown
  RegisterDirectMatch: '', // 'Registrer direkte match', // leave blank if it should not be shown
  contactConsentGiven: '', // 'indkøbsservice', // leave blank if it should not be shown

  u0Marker: '/assets/icons/dc3545-marker.png',
  siteMarker: '/assets/icons/008bff-marker.png',
  u2Marker: '/assets/icons/008bff-marker.png',
  u3Marker: '/assets/icons/fd7e14-marker.png',
  u4Marker: '/assets/icons/6f42c1-marker.png',
  u5Marker: '/assets/icons/40722c-marker.png',
  gMarker: '/assets/icons/6f42c1-marker.png',
  cMarker: '/assets/icons/007816-marker.png',
  eMarker: '/assets/icons/ffc107-marker.png',
  iMarker: '/assets/icons/6c757d-marker.png',
  nMarker: '/assets/icons/254e58-marker.png',
  p0Marker: '/assets/icons/ffc107-marker.png',
  p1Marker: '/assets/icons/e83e8c-marker.png',
  p2Marker: '/assets/icons/6f42c1-marker.png',
  p3Marker: '/assets/icons/6c757d-marker.png',
};
